import { useLanguage } from '../../../utils/sitecoreContext';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
import { useAppSelector } from '../../../core/utils';
export const DEFAULT_PROVIDER_SERVICE = 'MakeAnAppointment';
export const DEFAULT_LEAD_PROVIDER_SERVICE = 'Make An Appointment';
export const FEATURE_ORIGIN_INV = 'Inventory';
export const FEATURE_ORIGIN_BAP = 'BAP';
const generateSearchParamsPayload = ({ dealerCode, providerService, modelKey, modelYear, language }) => ({
    modelYear,
    model: modelKey,
    lang: language,
    dealerCode,
    providerService,
});
const useGetLinkSearchParams = ({ dealerCode = '', providerService = DEFAULT_PROVIDER_SERVICE, generatePayload = generateSearchParamsPayload }, stripEmptyParam = true) => {
    const language = useLanguage();
    const { modelKey, modelYear, trimKey, transmissionKey, exteriorColorKey, interiorColorKey } = useAppSelector(selectCurrentVehicle);
    const searchParamsPayload = generatePayload({
        modelYear,
        modelKey,
        trimKey,
        transmissionKey,
        exteriorColorKey,
        interiorColorKey,
        language,
        dealerCode,
        providerService,
    });
    const searchParams = new URLSearchParams();
    Object.entries(searchParamsPayload).forEach(([key, value]) => {
        if (value || !stripEmptyParam)
            searchParams.set(key, value);
    });
    searchParams.sort();
    return searchParams.toString();
};
export default useGetLinkSearchParams;
